import { render, staticRenderFns } from "./homeDashboardTrainerStatisticsDialog.vue?vue&type=template&id=22f34fc4&scoped=true"
import script from "./homeDashboardTrainerStatisticsDialog.vue?vue&type=script&lang=js"
export * from "./homeDashboardTrainerStatisticsDialog.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTrainerStatisticsDialog.vue?vue&type=style&index=0&id=22f34fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f34fc4",
  null
  
)

export default component.exports